import { fuenteVisibleEnLead } from "./procedenciaColor";
import { resolverPropiedadCompraCliente, cargarPropiedadExpediente } from "./resolverPropiedadCompraCliente";
import { mergeFinanzasExpediente } from "./finanzasExpedientePropiedad";

const ETAPA_LABEL = {
  clientes: "Clientes",
  atendidos: "Atendidos",
  visitantes: "Visitantes",
  calientes: "Calientes",
  ventas: "Ventas",
};

export function etiquetaEtapaLead(etapa) {
  return ETAPA_LABEL[etapa] || etapa || "";
}

export function nombreCompradorDesdeLead(lead) {
  const nombre = lead.cliente_id ? (lead.cli_nombre || lead.nombre || "") : (lead.nombre || "");
  const apellidos = lead.cliente_id ? (lead.cli_apellido || lead.apellido || "") : (lead.apellido || "");
  return { nombre, apellidos };
}

export function compradorYaEnExpediente(compradores, lead) {
  return (compradores || []).some(
    (c) =>
      (lead.lead_id && c.lead_id === lead.lead_id) ||
      (lead.cliente_id && c.cliente_id && c.cliente_id === lead.cliente_id)
  );
}

export function mergeAgentesExpediente(agentes, { ventaId, captacionId } = {}) {
  const arr = [...(agentes || [])];
  const upsert = (agente_id, concepto) => {
    if (!agente_id) return;
    const idx = arr.findIndex((a) => a.concepto === concepto);
    if (idx >= 0) {
      if (!arr[idx].agente_id) arr[idx] = { ...arr[idx], agente_id };
      return;
    }
    if (arr.some((a) => a.agente_id === agente_id && a.concepto === concepto)) return;
    arr.push({ agente_id, concepto });
  };
  upsert(ventaId, "Venta");
  upsert(captacionId, "Captación");
  return arr;
}

/** Añade comprador desde pipeline y, si es el primero, carga propiedad comprada + propietarios. */
export async function aplicarCompradorPipeline(lead, form, extras = {}) {
  const { nombre, apellidos } = nombreCompradorDesdeLead(lead);
  const nuevoComprador = {
    lead_id: lead.lead_id || null,
    cliente_id: lead.cliente_id || null,
    nombre: extras.nombre || nombre,
    apellidos: extras.apellidos || apellidos,
    porcentaje: extras.porcentaje ?? (form.compradores?.length === 0 ? 100 : ""),
    telefono: extras.telefono ?? lead.telefono ?? "",
    email: extras.email ?? lead.email ?? "",
    whatsapp: extras.whatsapp ?? lead.whatsapp ?? "",
    direccion: extras.direccion ?? "",
    estado_civil: extras.estado_civil ?? "",
    regimen_matrimonial: extras.regimen_matrimonial ?? "",
    profesion: extras.profesion ?? "",
    sexo: extras.sexo ?? "",
    nacionalidad: extras.nacionalidad ?? "",
  };

  const out = {
    compradores: [...(form.compradores || []), nuevoComprador],
    propiedades: [...(form.propiedades || [])],
    propietarios: [...(form.propietarios || [])],
    agentes: [...(form.agentes || [])],
    cliente_nombre: form.cliente_nombre,
    cliente_id: form.cliente_id,
    precio_venta: form.precio_venta,
    precio_propietario: form.precio_propietario,
    honorarios: form.honorarios,
    honorarios_iva: form.honorarios_iva,
    nos_conocio_por: form.nos_conocio_por,
    colaborador: form.colaborador,
  };

  const esPrimero = !(form.compradores || []).length;
  const clienteId = lead.cliente_id || null;

  if (esPrimero) {
    const nomExp = [nombre, apellidos].filter(Boolean).join(" ").trim();
    if (nomExp) out.cliente_nombre = nomExp;
    if (clienteId) out.cliente_id = clienteId;
  }

  if (!out.nos_conocio_por && lead.fuente) {
    const visible = fuenteVisibleEnLead(lead.fuente);
    if (visible) out.nos_conocio_por = visible;
  }

  let propAgenteId = lead.prop_agente_id || null;

  if (esPrimero && !out.propiedades.length) {
    const refCompra = await resolverPropiedadCompraCliente(clienteId, lead);
    const cargada = await cargarPropiedadExpediente({
      propiedad_id: refCompra.propiedad_id,
      referencia: refCompra.referencia,
      prop_direccion: lead.prop_direccion,
      prop_poblacion: lead.prop_poblacion,
      prop_provincia: lead.prop_provincia,
    });

    if (cargada) {
      out.propiedades = cargada.propiedades;
      out.propietarios = cargada.propietarios;
      Object.assign(out, mergeFinanzasExpediente(form, cargada, { precios_manual: form.precios_manual }));
      if (cargada.prop_agente_id) propAgenteId = cargada.prop_agente_id;
    }
  }

  out.agentes = mergeAgentesExpediente(out.agentes, {
    ventaId: lead.agente_id,
    captacionId: propAgenteId,
  });

  return out;
}
